module.exports = __webpack_public_path__ + "img/positiveEffects.3d634bb.jpg";